import AggloService from '../services/Agglo';
import MQTTService from '../services/mqtt';
import MapService from '../../services/map';
import Translate from '../../services/translate';

/**
 * ------------
 * Ville
 * ------------
 * @description
 * gère les événements sur la page ville.php
 * */
export default class Ville {

    constructor() {
        const mobile = !window.matchMedia("(min-width: 1000px)").matches;
        const options = {
            id: 'mapVille',
            style: Translate.print('map.home'),
            scrollZoom: false,
            interactive: false,
            center: [-2.5000, 45.8002],
            zoom: 5,
        };

        MQTTService.initMQTT();
        if (mobile) {
            AggloService.getAllAgglos().then(function () {
                AggloService.arElements = AggloService.networksList;
                AggloService.initHomeSearchAgglo();
                Ville.setListByOsmLevel(AggloService.arElements);
                Ville.showAggloList();
                Ville.animationTitle();
            });
        } else {
            MapService.initMap(options).then(function () {
                AggloService.getAllAgglos().then(function () {
                    MapService.drawEvent();
                    AggloService.arElements = AggloService.networksList;
                    AggloService.initHomeSearchAgglo();
                    Ville.setListByOsmLevel(AggloService.arElements);
                    Ville.showAggloList();
                    Ville.animationTitle();
                });
            });
        }
    }

    /**
     * -----------------
     * showAggloList
     * -----------------
     * @description
     * affiche la liste des agglos par osmLevel et remove le loader
     */
    static showAggloList = function () {
        $('[data-agglo-loader]').addClass('hide');
        $('[data-agglo-list]').addClass('active');
    }

    /**
     * ----------------
     * setListByOsmLevel
     * ----------------
     * @description
     * affiche la liste des agglos regroupées par osmLevel sur la page de recherche d'un réseau
     */
    static setListByOsmLevel = function (list) {
        $.each(list, function (index, item) {
            const agglo =
                '<li>' +
                    '<a target="_blank" rel="noreferrer noopener" href="https://maps.mybus.io/' + item.id + '">' + item.name + '</a>' +
                '</li>';
            $('[data-agglo-list-osmLevel="' + item.osmLevel + '"]').append(agglo);
        });
    }

    /**
     * --------------
     * animationTitle
     * --------------
     * @description
     * Gère l'animation du nombre de réseaux sur la page
     */
    static animationTitle = function () {
        let nbReseaux = parseInt($('[data-networks]').attr('data-networks')) + 1;
        let i = 1;
        const villeAnimation = setInterval(function () {
            $('[data-agglos-title]').text(i);
            i++;
            if (i >= nbReseaux) {
                clearInterval(villeAnimation);
            }
        }, 10);
    }
}

